module.exports = window["Bernie_l10nBundle_ko_KR"];